export default "__VITE_ASSET__C9hFquyu__"